// https://www.youtube.com/watch?v=YeSzQzfcQCs

<template >
  <div>
    <Enlarge :currentItem="this.currentItem" />
    <navbar  />
    <smallnav class="navbar-sm"/>
    <div class="container main-container">
      <div class="desktop-left">
        <div class="item-list">
            <ul :class="{'item-ischosen':item.chosen}" v-on:click="setChosen(item)" v-for="item in items" :key="'A'+item.id">
                <div class="desktop-image-sm" :style='{backgroundImage: "url(" + item.img.sample + ")"}'></div>
                <div class="descr-sm">
                  <li class="item">{{item.model}} {{item.specs["Core Frequency"]}}</li>
                  <li>{{getBenchmark(item)}}</li>
                  <div class="benckmark progress " :class='{"isChosen":item.chosen}'>
                      <div class="progress-bar bg-succsess" role="progressbar" :style='{width: getBenchmark(item)+"%"}' aria-valuenow="25" aria-valiemin="0" aria-valuemax="100"></div>
                  </div>
                </div>
            </ul>
        </div>
       
      </div>
      <div class="desktop-right">
        right
      </div>
      
    </div>
  </div>

</template>

<script>
import navbar from './components/navbar.vue'
import smallnav from './components/desktop/smallnav'
import { EventBus } from './eventBus'
// import {desktops} from './data.js.bcp'
import Enlarge from './components/default/Enlarge'

export default {
  name: 'Desktops',
  components:{
    navbar,
    smallnav,
    Enlarge
  },
  data() {
    return {
      currentItem:null,
      // brands: desktops.brands,
      // models: desktops.models,
      // items: desktops.items,
      viewModes: [
        {
          id: 1,
          name: "Slider",
          chosen: true
        },
        {
          id: 2,
          name: "List",
          chosen: false
        }
      ],
      compareList: [],  
    }
  },
  methods: {
    getBenchmark(item){
            var maxResult = 543;
            var currentResult = item.specs["CPU-Z Benchmark"];
            var procent = Math.round(currentResult*100.0 / maxResult) 
            return procent;
        },
    setChosen(item){
            //Resetting all items to !chosen
            for (var i = 0; i < this.items.length; i++){
                this.items[i].chosen = false
            }
            //Setting the item to chosen
            item.chosen = true
            //Assigning the currentItem to chosen item
            this.currentItem = item
            //Emitting event 
            EventBus.$emit('setChosen', item)
            // console.log(item.id-1)
        },
  }
}

</script>

<style scoped>
@import 'assets/css/custom.css';
@import 'assets/css/toolkit-inverse.css';
body {
  background-color: #191b20;
}
.main-container {
  width: 100%;
  height: 100%;
  

}
.navbar-sm{
  margin-top: 40px;
}
.desktop-left{
  display: inline-block;
  text-align: left;
  border: 1px solid white;
  width: 48%;
  overflow: scroll;
}
.item-list ul:hover {
  background-color: #434857;
}
.desktop-image-sm{
  display: inline-block;
  width: 100px;
  height: 100px;
  background-repeat: no-repeat;
  background-color: white;
  box-shadow: inset 0px 0px 10px 3px #191b20;
  background-origin: content-box;
  background-size: contain;
}
.descr-sm{
  display: inline-block;
  vertical-align: top;
  margin-left: 10px;
}







.desktop-right{
  float: right;
  display: inline-block;
  width:48%;
  border: 1px solid white;
}
.footer {
  position: absolute;
  bottom: 0px;
}
</style>
